import { SavedListCreatorType } from 'ui-components';
import { create } from 'zustand';

import { SavedListMapState, SavedListState } from './SavedListsModal.types';

type SavedListStateStore = {
  clearList: () => void;
  deleteList: (id: string | number) => void;
  lists: SavedListMapState;
  updateList: (id: string | number, state: SavedListState) => void;
  updateListCreator: (
    listId: string | number,
    state: SavedListCreatorType,
  ) => void;
};

export const useSavedListStateStore = create<SavedListStateStore>()((set) => ({
  clearList: () =>
    set(() => ({
      lists: {},
    })),
  deleteList: (id) =>
    set((state) => {
      const lists = { ...state.lists };
      delete lists[id];
      return { lists };
    }),
  lists: {},
  updateList: (id, updatedState) =>
    set((state) => ({
      lists: {
        ...state.lists,
        [id]: updatedState,
      },
    })),
  updateListCreator: (id, updatedState) =>
    set((state) => {
      const list = state.lists[id];
      const creators = list.creators.map((creator) =>
        creator.id === updatedState.id ? updatedState : creator,
      );
      return {
        lists: {
          ...state.lists,
          [id]: {
            ...list,
            creators,
          },
        },
      };
    }),
}));
